import { pettyCashService } from "../../../../../Api/Services/PettyCashService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IPettyCashAccountZoneDashboardServiceResponse } from "../../../../../Types/PettyCash";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const fetchEmployeePettyCashAccountZoneDashboard =
  createServiceAsyncThunk<
    IPettyCashAccountZoneDashboardServiceResponse,
    { activeYear: number }
  >(
    ACTION_NAMES.FETCH_EMPLOYEE_PETTY_CASH_ACCOUNT_ZONE_DASHBOARD,
    ({ activeYear }: { activeYear: number }) =>
      pettyCashService.pettyCashDashboardAccountZone({
        active_year: activeYear,
      }),
    ERROR_MESSAGES.EMPLOYEE_PETTY_CASH_ACCOUNT_ZONE_DASHBOARD_FAILURE
  );

export const employeePettyCashAccountZoneDashboardSlice = createGenericSlice<
  IPettyCashAccountZoneDashboardServiceResponse,
  { activeYear: number }
>(
  SLICE_NAMES.EMPLOYEE_PETTY_CASH_ACCOUNT_ZONE,
  fetchEmployeePettyCashAccountZoneDashboard
);

export const { clearError: clearEmployeePettyCashAccountZoneDashboardErrors } =
  employeePettyCashAccountZoneDashboardSlice.actions;

export default employeePettyCashAccountZoneDashboardSlice.reducer;
